import moment from "moment";

export const getYesterday = () => {
  const now = new Date();
  now.setDate(now.getDate() - 1);
  return now.toUTCString();
};

export const inOneYear = () => {
  const now = new Date();
  now.setDate(now.getDate() + 365);
  return now.toUTCString();
};

export const inOneCentury = () => {
  const now = new Date();
  now.setDate(now.getDate() + 36500);
  return now.toUTCString();
};

export const compareTimestampOrNull = (ts1: any, ts2: any) => {
  if (ts1 === null && ts2 === null) {
    return 0;
  }
  if (ts1 !== null && ts2 === null) {
    return -1;
  }
  if (ts1 === null && ts2 !== null) {
    return 1;
  }
  const ts1Moment = moment(ts1);
  const ts2Moment = moment(ts2);

  if (ts1Moment.isSame(ts2Moment)) {
    return 0;
  }

  return ts1Moment.isBefore(ts2Moment) ? -1 : 1;
};

export const isYearMonthDay = (t: string) => {
  const yearMonthDay = /^\d{4}-\d{1,2}-\d{1,2}$/; // eg 2020-01-02, 2020-1-2

  return yearMonthDay.test(t);
};

export const isMonthDayYear = (t: string) => {
  const monthDayYear = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/; // eg 01/02/2020, 1/2/20

  return monthDayYear.test(t);
};

export const isValidDate = (t: string) => isYearMonthDay(t) || isMonthDayYear(t);

export default getYesterday;
